import React from 'react';

const EmailVerified = () => {
	return <div>Correo Verificado</div>;
};

export default EmailVerified;
